var Curriculog = Curriculog || {};

Curriculog.UserRoleView = (function ($, _, Backbone, UserRoleView) {

	UserRoleView = Curriculog.CurriculogView.extend({
		template: 'HierarchyList/userRoleListItem.html',

		initialize: function (options) {
			this.user = options.user;
			this.users = options.users;
			this.depth = options.depth;
			this.userRole = options.userRole;
      this.params = options.params;
			this.listenTo(this.userRole, 'change', this.updateUserRole);
			this.render();
		},

		updateUserRole: function () {
			var userID = this.userRole.get('user_id');
			this.user = this.users.get(userID);
			this.render();
		},

		render: function () {
			templateData = {
				'userName': this.user.name(),
				'depth': this.depth,
				'userRole': this.userRole.toJSON(),
        'cui_enabled': this.params.cui_enabled
			}

			this.el = nunjucks.render(this.template, templateData);
			this.replaceElement(this.el);
		}
	});
	return UserRoleView;

})($, _, Backbone, Curriculog.UserRoleView || {});
